import { ActivityTransitionAgentToolInputOverride } from '../Models/FlowModel';

type InputOverrideChange = Partial<Pick<ActivityTransitionAgentToolInputOverride, 'Enabled' | 'Description' | 'Override'>>;

/** Update one edge-owned field without erasing other settings or another activity's bindings. */
export function updateAgentToolInputOverride(
	inputs: ActivityTransitionAgentToolInputOverride[] | undefined,
	activityId: string,
	propertyName: string,
	change: InputOverrideChange,
): ActivityTransitionAgentToolInputOverride[] | undefined {
	const matches = (input: ActivityTransitionAgentToolInputOverride) =>
		input.ActivityId === activityId && input.PropertyName.toLowerCase() === propertyName.toLowerCase();
	const existing = inputs?.find(matches);
	if (!existing && Object.values(change).every((value) => value === undefined)) return inputs;
	const next = { ActivityId: activityId, PropertyName: propertyName, ...existing, ...change };
	const remaining = (inputs ?? []).filter((input) => !matches(input));
	if (next.Enabled != null || next.Description !== undefined || next.Override !== undefined) {
		remaining.push({ ...next, Enabled: next.Enabled ?? null });
	}
	return remaining.length ? remaining : undefined;
}

export function removeAgentToolInputOverride(inputs: ActivityTransitionAgentToolInputOverride[], activityId: string, propertyName: string) {
	const remaining = inputs.filter((input) => !(input.ActivityId === activityId && input.PropertyName.toLowerCase() === propertyName.toLowerCase()));
	return remaining.length ? remaining : undefined;
}
